module.exports = "/src/views/player/help/images/daln2.jpg";